<template>
  <div>
    <div class="content">
      <template v-if="!$parent.port || $parent.intake.rekeningData.type == 'Bedrijfsrekening'">
        <button
          v-if="
            $parent.intake.goalData.box != '1'
            && !$parent.port
            && $parent.intake.goalData.type != 'studiekinderen'
          "
          @click="modelValue.type = '';$parent.resetType()"
          style="float:right;cursor:pointer;"
          class="secondary setting"
          title="Mijzelf / Samen (en/of) / Mijn bedrijf"
        >
        <awesomeIcon icon="edit" title="Mijzelf / Samen (en/of) / Mijn bedrijf" />
        Type rekening wijzigen
        </button>
        <button
          v-if="
            (
              $parent.intake.rekeningData.step > 0
              && $parent.intake.rekeningData.type != 'Minderjarige rekening'
            )
            || $parent.intake.rekeningData.step > 1
          "
          @click="$parent.deletePerson(index)"
          class="secondary setting"
        >
          <awesomeIcon icon="trash" /> Verwijderen
        </button>
      </template>

      <h2 class="title">
        <awesomeIcon icon="user" /> {{ modelValue.type }}
        <template v-if="!$parent.port || $parent.intake.rekeningData.type == 'Bedrijfsrekening'">
          <button
            @click="
              modelValue.type = '';
              $parent.storeIntake(2, $parent.intake.rekeningData.step);
            "
            v-if="
              $parent.intake.rekeningData.type != 'Minderjarige rekening'
              && modelValue.type
              && (role > 8 || $parent.intake.rekeningData.type == 'Bedrijfsrekening' )
            "
            class="secondary"
          >
            <awesomeIcon icon="edit" title="Rol wijzigen"/>
          </button>
        </template>
      </h2>

      <customInput
        type="text"
        label="Roepnaam"
        placeholder="Hoe mogen wij u noemen?"
        v-model="modelValue.roepnaam"
      />

      <customInput
        v-if="$parent.intake.rekeningData.step != 0"
        v-model="modelValue.email"
        type="text"
        label="E-mail"
        :validation="[
          (modelValue.type == 'Minderjarige'
            || (
              $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen'
              && $parent.intakeAdmin.beleggen.brand !== 'OXBY'
            )
          )
            ? 'notrequired'
            : 'email',
        ]"
      />
      <customInput
        v-else
        v-model="$parent.email"
        type="text"
        label="E-mail"
        :disabled="true"
      />

      <div class="flex-container flex-grow">
        <customInput
          v-model="modelValue.telefoonnummer"
          type="text"
          label="Telefoonnummer"
          placeholder="Vul hier uw telefoonnummer in"
          :validation="[
            modelValue.type == 'Minderjarige'
              ? 'notrequired'
              : '',
              'phone',
          ]"
        />
        <customInput
          v-if="
            $parent.intakeAdmin.beleggen.brand == 'VMVB'
            || $parent.intakeAdmin.beleggen.brand == 'BVS'
          "
          v-model="modelValue.telefoonnummer2"
          type="text"
          label="Telefoonnummer extra"
          :validation="['notrequired', 'phone']"
        />
      </div>

      <div class="subheader">Adres</div>

      <template v-if="$parent.intake.rekeningData.step != 0">
        <customInput
          v-model="modelValue.zelfdeAdres"
          type="yesno"
          label="Woont deze persoon op hetzelfde adres als u?"
        />
        <div
          v-if="modelValue.zelfdeAdres != 'No'"
          class="msg"
        >
          {{ $parent.intake.persoonsData[0].straat }}
          <span v-if="!$parent.intake.persoonsData[0].straat">Straat</span>
          {{ $parent.intake.persoonsData[0].huisnummer }}
          <span v-if="!$parent.intake.persoonsData[0].huisnummer">Huisnummer</span>
          {{ $parent.intake.persoonsData[0].toevoeging }}
          <br />
          {{ $parent.intake.persoonsData[0].postcode }}
          <span v-if="!$parent.intake.persoonsData[0].postcode">Postcode</span>
          {{ $parent.intake.persoonsData[0].plaats }}
          <span v-if="!$parent.intake.persoonsData[0].plaats">Plaats</span>
          , {{ $parent.intake.persoonsData[0].land }}
          <span v-if="!$parent.intake.persoonsData[0].land">Land</span>
        </div>
      </template>

      <template
        v-if="$parent.intake.rekeningData.step == 0
          || modelValue.zelfdeAdres == 'No'
        "
      >
        <div class="flex-container flex-grow">
          <customInput
            type="text"
            v-model="modelValue.postcode"
            label="Postcode"
            placeholder="1111AA"
            @changed="doZipCall"
          />
          <customInput
            type="text"
            v-model="modelValue.huisnummer"
            label="Huisnummer"
            @changed="doZipCall"
          />
          <customInput
            type="text"
            v-model="modelValue.toevoeging"
            label="Toevoeging"
            :validation="['notrequired']"
            @changed="doZipCall"
          />
        </div>

        <div class="flex-container flex-grow">
          <customInput
            type="text"
            v-model="modelValue.straat"
            label="Straat"
          />
          <customInput
            type="text"
            v-model="modelValue.plaats"
            label="Woonplaats"
          />
          <customInput
            v-model="modelValue.land"
            type="dropdown"
            label="Land"
            :options="allCountries"
          />
        </div>
        <div
            v-if="modelValue.postadres == 'Yes'
             || ($parent.intakeAdmin.beleggen.brand == 'VMVB'
              || $parent.intakeAdmin.beleggen.brand == 'BVS'
            )"
          class="subheader"
        >
          Afwijkend postadres
        </div>
        <customInput
          v-if="$parent.intake.rekeningData.step == 0
            && ($parent.intakeAdmin.beleggen.brand == 'VMVB'
            || $parent.intakeAdmin.beleggen.brand == 'BVS')
          "
          v-model="modelValue.postadres"
          type="yesno"
          label="Afwijkend postadres?"
        />
        <customInput
          v-else-if="modelValue.postadres == 'Yes'
            && ($parent.intakeAdmin.beleggen.brand == 'Doelbeleggen'
              || $parent.intakeAdmin.beleggen.brand == 'OXBY'
            )
          "
          v-model="modelValue.postadres"
          type="yesno"
          label="Wilt u het afwijkend postadres behouden?"
        />
      </template>
      <template v-if="modelValue.postadres == 'Yes' && $parent.intake.rekeningData.step == 0">
        <div class="flex-container flex-grow">
          <customInput
            type="text"
            v-model="modelValue.postPostcode"
            label="Postcode"
          />
          <customInput
            type="text"
            v-model="modelValue.postHuisnummer"
            label="Huisnummer"
          />
          <customInput
            type="text"
            v-model="modelValue.postToevoeging"
            label="Toevoeging"
            :validation="['notrequired']"
          />
        </div>

        <div class="flex-container flex-grow">
          <customInput
            label="Straat"
            type="text"
            v-model="modelValue.postStraat"
          />
          <customInput
            label="Woonplaats"
            type="text"
            v-model="modelValue.postPlaats"
          />
          <customInput
            label="Land"
            v-model="modelValue.postLand"
            type="dropdown"
            :options="allowedCountries"
          />
        </div>
      </template>
      <template
        v-if="
          !$parent.redo
          || $parent.redo
          && (
            !modelValue.vervalDatum
            || new Date(Date.now()) > new Date(modelValue.vervalDatum)
            || (
              $parent.previousIntake.persoonsData[index].vervalDatum
              && new Date(Date.now()) > new Date(
                $parent.previousIntake.persoonsData[index].vervalDatum
              )
            )
          )
          || role > 7
        "
      >
        <div class="subheader">
          Voor het {{ $parent.redo == 1 ? 'aanhouden' : 'openen' }} van de rekening hebben wij een
          geldig kopie van uw paspoort of ID-kaart nodig.<br />
          Gaat u uw paspoort of ID-kaart uploaden?  {{ role > 7 && $parent.redo ? '(admin)' : '' }}
        </div>
        <customInput
          v-for="(option, key) in identificationUploadOptions"
          v-model="modelValue.identificationType"
          :key="key + 'identificationType'"
          type="radio2"
          name="radiogroup1"
          :label="option.label"
          :option="option.value"
        />
        <template v-if="modelValue.identificationType || role > 7">
          <div class="msg">
            <ul style="padding-left:13px; margin:0px;">
              <li v-if="modelValue.dutchNationality !== 'No'">
                <b><u>Let op, geen rijbewijs</u></b>
              </li>
              <li v-if="modelValue.dutchNationality !== 'No'
                  && modelValue.identificationType === 'id'
              ">
                Omdat u een ID-kaart gaat uploaden, graag voor- en achterkant.
              </li>
              <li>
                Toegestane bestandsformaten zijn: JPG, PNG, GIF en PDF.
              </li>
              <li style="cursor: pointer;" @click="infoModal = true">
                {{ $parent.intake.rekeningData.step == 0 ? 'Uw ' : 'Deze persoon zijn '}}
                kopie mag niet afgeschermd zijn, <u>meer informatie</u>.
              </li>
              <template
                v-if="
                  $parent.redo
                  && modelValue.vervalDatum
                  && (
                    new Date(Date.now()) > new Date(modelValue.vervalDatum)
                    || new Date(Date.now()) > new Date(
                      $parent.previousIntake.persoonsData[index].vervalDatum)
                  )
                "
              >
                <br />
                <b style="margin-left: -13px;">
                  Uw identiteitsbewijs is verlopen, upload hieronder een geldig kopie van uw
                  paspoort of ID-kaart.
                </b>
              </template>
            </ul>
          </div>
          <customInput
            v-model="modelValue.files"
            type="file"
            :prefix="`legitimatie${Number($parent.intake.rekeningData.step)}`"
            :validation="['files']"
          />
        </template>
      </template>

      <div
        class="subheader"
        v-if="
          (
            !$parent.redo
            || $parent.redo && (
              !modelValue.vervalDatum
              || new Date(Date.now()) > new Date(modelValue.vervalDatum)
              || (
                $parent.previousIntake.persoonsData[index].vervalDatum
                && new Date(Date.now()) > new Date(
                  $parent.previousIntake.persoonsData[index].vervalDatum
                )
              )
            )
          )
          || role > 7
        "
        >
        Voor de volgende vragen heeft
        {{ $parent.intake.rekeningData.step == 0 ? 'u uw ' : 'deze persoon zijn '}}
        paspoort of ID-kaart nodig
        {{ role > 7 && $parent.redo ? '(admin)' : '' }}
      </div>

      <div
        v-if="
          (
            !$parent.redo
            || $parent.redo && (
              !modelValue.vervalDatum
              || new Date(Date.now()) > new Date(modelValue.vervalDatum)
              || (
                $parent.previousIntake.persoonsData[index].vervalDatum
                && new Date(Date.now()) > new Date(
                  $parent.previousIntake.persoonsData[index].vervalDatum
                )
              )
            )
          )
          || role > 7
        "
        :class="$parent.redo && role > 7 ? 'admin-screen msg' : '' "
      >
        <div v-if="!$parent.redo || role > 7" class="flex-container flex-grow">
          <customInput
            ref="focus"
            type="text"
            :placeholder="
              `Zoals in ${
                $parent.intake.rekeningData.step == 0
                  ? 'uw'
                  : 'deze persoon zijn '
              } paspoort of ID-kaart`
            "
            label="Voorletter(s)"
            v-model="modelValue.voorletters"
          />
          <customInput
            ref="focus"
            type="text"
            label="Voorna(a)m(en)"
            :placeholder="
              `Zoals in ${
                $parent.intake.rekeningData.step == 0
                  ? 'uw'
                  : 'deze persoon zijn '
              } paspoort of ID-kaart`
            "
            v-model="modelValue.voornaam"
          />
        </div>

        <div v-if="!$parent.redo || role > 7" class="flex-container flex-grow">
          <customInput
            type="text"
            label="Tussenvoegsel"
            v-model="modelValue.tussenvoegsel"
            :validation="['notrequired']"
            class="flex-grow-half flex-50"
          />
          <customInput
            type="text"
            class="flex-50"
            label="Achternaam"
            :placeholder="
              `Zoals in ${
                $parent.intake.rekeningData.step == 0
                  ? 'uw'
                  : 'deze persoon zijn '
              } paspoort of ID-kaart`
            "
            v-model="modelValue.achternaam"
          />
        </div>

        <div v-if="!$parent.redo || role > 7" class="flex-container flex-grow">
          <customInput
            class="flex-50"
            type="dropdown"
            v-model="modelValue.geslacht"
            label="Geslacht"
            :options="[
              {label:'Vrouw', value:'vrouw'},
              {label:'Man', value:'man'},
            ]"
          />
          <customInput
            class="flex-50"
            v-model="modelValue.geboorteDatum"
            type="date"
            label="Geboortedatum"
            :maxDatetime="new Date()"
            :validation="['max']"
          />
        </div>

        <div v-if="!$parent.redo || role > 7" class="flex-container flex-grow">
          <customInput
            v-model="modelValue.geboortplaats"
            type="text"
            :placeholder="
              `Zoals in ${
                $parent.intake.rekeningData.step == 0
                  ? 'uw'
                  : 'deze persoon zijn '
              } paspoort of ID-kaart`
            "
            label="Geboorteplaats"
          />
          <customInput
            v-model="modelValue.geboorteland"
            type="dropdown"
            label="Geboorteland"
            :options="allCountries"
          />
        </div>

        <div class="flex-container flex-grow">
          <customInput
            v-model="modelValue.documentnummer"
            type="text"
            class="flex-50"
            :placeholder="
              `Zoals in ${
                $parent.intake.rekeningData.step == 0
                  ? 'uw'
                  : 'deze persoon zijn '
              } paspoort of ID-kaart`
            "
            label="Documentnummer"

          />
          <customInput
            v-model="modelValue.vervalDatum"
            type="date"
            class="flex-50"
            label="Vervaldatum paspoort of ID-kaart"
            :minDatetime="new Date(new Date().setFullYear(new Date().getFullYear()))"
            :maxDatetime="new Date(new Date().setFullYear(new Date().getFullYear() + 100))"
            :validation="['min', 'max']"
          />
        </div>

        <template v-if="$parent.financeFilter(modelValue) && (!$parent.redo || role > 7)">
          <customInput
            v-model="modelValue.belastingsplichtigBuitenland"
            type="yesno"
            :label="
              index == 0
                ? 'Bent u inkomstenbelastingplichtig buiten Nederland?'
                : 'Is deze persoon inkomstenbelastingplichtig buiten Nederland?'
            "
          />
          <customInput
            v-if="modelValue.belastingsplichtigBuitenland == 'Yes'"
            v-model="modelValue.belastingsplichtingLand"
            type="dropdown"
            label="Welk land"
            :options="allCountries"
          />
        </template>
        <customInput
          v-if="!$parent.redo || role > 7"
          v-model="modelValue.bsn"
          :placeholder="
            `Zoals in ${
              $parent.intake.rekeningData.step == 0
                ? 'uw'
                : 'deze persoon zijn '
            } paspoort of ID-kaart`
          "
          type="text"
          :label="
            modelValue.belastingsplichtigBuitenland !== 'Yes' || $parent.intake.goalData.box == '1'
              ? 'Burgerservicenummer'
              : 'TIN (Tax Identification Number)'
          "
          :validation="[
            modelValue.belastingsplichtigBuitenland !== 'Yes' || $parent.intake.goalData.box == '1'
              ? 'bsn'
              : '',
          ]"
        />

        <customInput
          v-if="!$parent.redo || role > 7"
          :label="
            $parent.intake.rekeningData.step == 0
              ? `Heeft u de Nederlandse nationaliteit?`
              : `Heeft deze persoon de Nederlandse nationaliteit?`
          "
          v-model="modelValue.dutchNationality"
          @changed="switchNationality"
          type="yesno"
        />

        <customInput
          v-if="modelValue.dutchNationality == 'No' && (!$parent.redo || role > 7)"
          v-model="modelValue.nationaliteit"
          type="dropdown"
          label="Nationaliteit"
          :options="allCountries"
        />

        <p class="msg" v-if="modelValue.dutchNationality === 'No' && (!$parent.redo || role > 7)">
          Omdat {{
            $parent.intake.rekeningData.step == 0
              ? 'u'
              : 'deze persoon'
          }} een niet-Nederlandse nationaliteit heeft, kan het zijn dat wij meer
          documenten opvragen.
        </p>

        <customInput
          v-if="!$parent.redo || role > 7"
          :label="
            $parent.intake.rekeningData.step == 0
              ? `Heeft u een tweede nationaliteit?`
              : `Heeft deze persoon een tweede nationaliteit?`
          "
          v-model="modelValue.secondNationality"
          type="yesno"
        />

        <customInput
          v-if="modelValue.secondNationality == 'Yes' && (!$parent.redo || role > 7)"
          label="Welke nationaliteit?"
          v-model="modelValue.secondNationalityName"
          type="text"
        />

        <customInput
          v-if="!$parent.redo || role > 7"
          :label="
            $parent.intake.rekeningData.step == 0
              ? 'Bent u een US-person?'
              : 'Is deze persoon een US-person?'
          "
          v-model="modelValue.usperson"
          type="yesno"
        />

        <template v-if="!$parent.redo || role > 7">
          <div v-if="modelValue.usperson !== 'Yes'" class="msg">
            {{$parent.intake.rekeningData.step == 0
              ? `U bent bijvoorbeeld een US-person wanneer u Amerikaans staatsburger en/of inwoner
              van de Verenigde Staten bent of bent geweest.`
              : `Deze persoon is bijvoorbeeld een US-person wanneer deze persoon Amerikaans
              staatsburger en/of inwoner van de Verenigde Staten is geweest.`
            }}
          </div>
          <div v-else class="msg error">
            {{$parent.intake.rekeningData.step == 0
              ? `Let op, u kunt geen rekening aanvragen als u een US-person bent.`
              : `Let op, deze persoon kan geen rekening aanvragen als deze persoon een US-person
              is.`
            }}
          </div>
        </template>
      </div>
    </div>

    <modalWindow v-show="infoModal" @close="infoModal=false;" width="400">
      <div class="titlebar">Paspoort / Identiteitskaart</div>
      <div class="inset">
        Wij zijn verplicht om de identiteit van onze klanten vast te stellen door de wettelijke
        verplichtingen ter voorkoming van witwassen en terrorismefinanciering (Wwft). Ook zijn wij
        door de belastingdienst verplicht uw BSN te verwerken.
        <img
          src="../../assets/img/pass3.jpg"
          style="width:100%; margin:10px auto; display:block;"
        />
        <ul style="padding-left:13px;">
          <li>Achternaam</li>
          <li>Voornaam en voorletters</li>
          <li>Geboortedatum</li>
          <li>Documentnummer</li>
          <li>Geldigheidsdatum</li>
          <li>Geboorteplaats (bij ID-kaart op achterkant)</li>
          <li>Nationaliteit</li>
          <li>Burgerservicenummer (bij ID-kaart op achterkant)</li>
        </ul>
        Soms wordt het burgerservicenummer op een aparte pagina in uw paspoort vermeld.
        Maakt u in dat geval dan ook een kopie van deze pagina.
      </div>
    </modalWindow>
  </div>
</template>

<script>
export default {
  name: 'IntakePersonPage',
  emits: ['update:model-value'],
  data() {
    return {
      adminToggle: false,
      callTimer: null,
      previousCall: '',
      infoModal: false,
      identificationUploadOptions: [
        { label: 'Paspoort', value: 'paspoort' },
        { label: 'ID-kaart', value: 'id' },
      ],
    };
  },
  props: {
    modelValue: Object,
    index: Number,
  },
  watch: {
    index() {
      this.setDefaults();
    },
  },
  created() {
    this.setDefaults();
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    value() {
      return this.modelValue;
    },
    allowedCountries() {
      return Object.values(this.$parent.allowedCountries).reduce((obj, key) => {
        obj.push({
          label: key,
          value: key,
        });
        return obj;
      }, []);
    },
    allCountries() {
      return Object.values(this.$parent.allCountries).reduce((obj, key) => {
        obj.push({
          label: key,
          value: key,
        });
        return obj;
      }, []);
    },
  },
  methods: {
    setDefaults() {
      if (!this.modelValue.land) {
        this.$parent.intake.persoonsData[this.index].land = 'Nederland';
        this.$parent.intake.persoonsData[this.index].geboorteland = 'Nederland';
        this.$parent.intake.persoonsData[this.index].nationaliteit = 'Nederland';
      }
    },
    switchNationality() {
      if (this.modelValue.dutchNationality === 'Yes') {
        this.$parent.intake.persoonsData[this.index].nationaliteit = 'Nederland';
      }
    },
    doZipCall() {
      if (this.modelValue.postcode) {
        this.modelValue.postcode = `${this.modelValue.postcode}`.replace(/\s/g, '').toUpperCase();
        const call = `${
          this.modelValue.land
        }#${this.modelValue.postcode}#${
          this.modelValue.huisnummer
        }#${this.modelValue.toevoeging}`;
        if (
          call !== this.previousCall
          && this.modelValue.postcode
          && this.modelValue.huisnummer
          && this.modelValue.land === 'Nederland'
        ) {
          clearTimeout(this.callTimer);
          this.callTimer = setTimeout(this.zipCall, 1000);
        }
        this.previousCall = call;
      }
    },
    zipCall() {
      this.sdk.getIntakeZip(
        this.getQueryVariable('intake'),
        this.modelValue.postcode,
        this.modelValue.huisnummer,
        this.modelValue.toevoeging,
        (response) => {
          if (response.status === 200) {
            if (!response.data.exception) {
              this.modelValue.straat = response.data.street;
              this.modelValue.plaats = response.data.city;
            }
          } else {
            // error
          }
        },
      );
    },
  },
};
</script>
